import React, { useState,useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setYearList,setMonthList,setDateRange,formatDate } from './Function';
import { usePage } from '../PageContext';
import { Row, Col, Card, Table, Placeholder, Form, Button, Nav, Spinner } from 'react-bootstrap';
const SocietyDetails = ({htaccess}) => 
{
    const { currentPage } = usePage();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[Society,setSociety]=useState([]);
    useEffect(()=>
    {
        const SocietyDetails = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"clubs/details/"+htaccess);
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(
                            e => fetch(global.config.API_URL + "clubsUser/" + e.sc_id)
                                .then(up => up.json())
                        )
                    ).then(ups => {
                        ups.forEach((el, i) => {
                            result[i].users = (el.length > 0) ? el[0].users : [];
                        });
                        setLoading(false);
                        setSociety(result);
                        currentPage(result[0]);
                    }).catch(error => {
                        console.error('SocietyDetails File :', error);
                    });
                }
                else
                {
                    setSociety([]);
                    setLoading(false);            
                }
                if( global.config.IsPrint === true ) { console.info('SocietyDetails : Result',result); }
            } catch (error)
            {
                console.error('SocietyDetails : Error', error.message);
                setLoading(false);
            }
        };
        SocietyDetails();
        // eslint-disable-next-line
    },[htaccess])
    
    return (
        <React.Fragment>
        {isLoading ? (
            <div className='text-start'>
                <Card>
                    <Card.Header className='fs-4 text-uppercase'><Placeholder xs={10} /></Card.Header>
                    <Card.Body>
                        {[...Array(10)].map((_,index)=>(
                        <Card key={index} className='border-0'>
                            <Card.Header className='text-bg-info bg-info-subtle rounded text-uppercase'><Placeholder xs={5} /></Card.Header>
                            <Card.Body>
                                <Placeholder xs={10} />
                                <Placeholder xs={12} />
                                <Placeholder xs={7} />
                            </Card.Body>
                        </Card>
                        ))}
                    </Card.Body>
                </Card>
            </div>
        ) : (
            <React.Fragment>
            {Society.length > 0 ? (
            <React.Fragment>
            {Society.map((sc,index)=>(
            <div className='text-start' key={index}>
                <Card className='text-bg-info bg-info-subtle important-background mb-4'>
                    <Card.Header className='fs-4 text-uppercase text-center'>
                        {appLanguage === 'hi' ? (sc.sc_display_en === "1" ? sc.sc_name_hi || '' : sc.sc_name_hi || sc.sc_name) : sc.sc_name}
                    </Card.Header>
                    <Card.Body>
                        <div dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (sc.sc_display_en === "1" ? sc.sc_detail_hi || '' : sc.sc_detail_hi || sc.sc_detail) : sc.sc_detail}} ></div>
                        {sc.users.su_id &&
                        <div className='text-bg-info bg-info-subtle p-2 border border-2 my-3 d-flex'>
                            {t('FacultyAdvisor')} : {appLanguage === 'hi' ? sc.users.su_name_hi || sc.users.su_name : sc.users.su_name} 
                            {sc.users.departments && 
                            <span className='ms-2'>{appLanguage === 'hi' ? 'विभाग' : 'Department of'} {appLanguage === 'hi' ? sc.users.departments.sd_fullname_hi || sc.users.departments.sd_fullname : sc.users.departments.sd_fullname}</span>}
                        </div>}
                        <Nav as="ul" data-aos="flip-left" data-aos-duration="1500">
                            <Nav.Item as="li">
                                <Nav.Link href={sc.sc_facebook} target="_blank" rel="noopener noreferrer" className="social" style={{background:"#1877f2",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Facebook')+" "+t('Page')}>
                                    <i className="bi bi-facebook"></i>
                                    <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Nav.Link href={sc.sc_instagram} target="_blank" rel="noopener noreferrer" className="social" style={{background:"#f77737",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Instagram')+" "+t('Page')}>
                                    <i className="bi bi-instagram"></i>
                                    <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                </Nav.Link>
                            </Nav.Item>                            
                            <Nav.Item as="li">
                                <Nav.Link href="" target="_blank" rel="noopener noreferrer" className="social" style={{background:"#0a66c2",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Linkedin')+" "+t('Page')}>
                                    <i className="bi bi-linkedin"></i>
                                    <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Nav.Link href="" target="_blank" rel="noopener noreferrer" className="social" style={{background:"#ff0000",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Youtube')+" "+t('Channel')}>
                                    <i className="bi bi-youtube"></i>
                                    <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Card.Body>
                </Card>
                <ClubEvents scId={sc.sc_id} />
            </div>
            ))}
            </React.Fragment>
            ) : (
            <div className='text-center lead fw-bold'>
                {appLanguage === 'hi' ? 'हम वह क्लब/सोसायटी नहीं ढूंढ पाए जिसका विवरण हम आपको दिखाना चाहते थे।' : "We can't find the club/society whose details we wanted to show you."}
            </div>
            )}            
            </React.Fragment>
        )}
        </React.Fragment>
    );
}
export default SocietyDetails;

const ClubEvents = ({scId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[isLoadMore, setLoadMore] = useState(true);
    const[Rows, setRows] = useState(0);
    const[Events,setEvents]=useState([]);
    const[keyword, setKeyword] = useState('');
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(()=>
    {
        fetchEvents(true);
        // eslint-disable-next-line
    },[scId])
    const fetchEvents = async (isReset) => 
    {
        if (isReset === true) 
        {
            setRows(0);
            setEvents([]);
        }
        try 
        {
            setLoading(true);
            var sdId = 0;
            var keywordText = keyword || 'none';
            const currentRows = isReset ? 0 : Rows;
            const { startDate, endDate } = setDateRange(year, month, 1, 0, 0);
            const callApi = global.config.API_URL + `events/list/${sdId}/${scId}/${keywordText}/${startDate}/${endDate}/${currentRows}`;
            if(global.config.IsPrint) console.info('EventsList : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if (result.length > 0) 
            {
                setEvents(prevResults => Rows === 0 ? result : [...prevResults, ...result]);
                setRows(currentRows + 30);             
                setLoadMore(true);
            } 
            else 
            {
                setLoadMore(false);
            }
            if( global.config.IsPrint === true ) { console.info('EventsList : Result',result); }
        }
        catch (error) 
        { 
            console.error('EventsList : Error', error.message);
        }
        finally
        {
            setLoading(false);
        }
    };
    const handleSubmit = (e) => 
    {
        if (e)
        {
            e.preventDefault();
            if (!keyword && year === 0 && month === 0) 
            {
                alert(t('FilterAlert'));
                return;
            }
        }
        fetchEvents(true);
    }
    return (
        <Card className=' mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase'>
                {t('ClubEvents')}
            </Card.Header>
            <Card.Body>
                <Card className='mb-3'>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                            <Row className='g-2'>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Control type="text" placeholder={t('FilterPlaceholder')} onChange={KeywordChange} value={keyword} />
                                </Col>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Select onChange={YearChange} value={year}>
                                        <option value={0}>{t('FilterYear')}</option>
                                        {setYearList(1, 0).map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Select onChange={MonthChange} value={month}>
                                        <option value={0}>{t('FilterMonth')}</option>
                                        {setMonthList().map(({ value, label }) => (
                                            <option key={value} value={value}>
                                                {label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={3} className='d-grid' data-aos="fade-left" data-aos-duration="1000">
                                    <Button type="submit" className='btn btn-info'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                    <thead>
                    <tr>
                        <th className='w-50'>{t('Title')}</th>
                        <th>{t('Duration')}</th>
                        <th>{t('Download')}</th>
                    </tr>                    
                    </thead>
                    {isLoading ? (
                    <tbody>
                        {[...Array(10)].map((_,index)=>(
                        <tr key={index}>
                            <th className="table-success"><Placeholder xs={10} /></th>
                            <td className="text-center"><Placeholder xs={10} /></td>
                            <td className="text-center">
                                <Button className="btn btn-light w-75"><Placeholder xs={12} /></Button>
                            </td>                            
                        </tr>
                        ))}
                    </tbody>
                    ) : (
                    <React.Fragment>
                    {Events.length > 0 ? (
                    <tbody>
                    {Events.map((se,index)=>(
                    <tr key={index}>
                        <th className="table-success" dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (se.se_display_en === "1" ? se.se_name_hi || '' : se.se_name_hi || se.se_name) : se.se_name }}></th>
                        <td className="text-center">{formatDate(se.se_start_duration)} TO {formatDate(se.se_end_duration)}</td>
                        <td className="text-center">
                            <NavLink to={appLanguage ==='hi' ? `/घटनाक्रम/विवरण/${se.se_htaccess_hi || se.se_htaccess}` : `/event/details/${se.se_htaccess}`} className="btn btn-light" target='_blank' rel="noopener noreferrer">
                                {t('ViewDownload')}
                            </NavLink>
                        </td>
                    </tr>
                    ))}
                    </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan={3} className='text-center'>{t('NoResult')}</td>
                            </tr>
                        </tbody>
                    )}
                    </React.Fragment>                    
                )}
                </Table>               
            </Card.Body>
            <Card.Footer className='d-flex justify-content-between bg-white'>
                {isLoadMore &&
                <Button variant='info' onClick={() => fetchEvents(false)} disabled={isLoading}>
                    {isLoading ? (
                    <React.Fragment>
                        <Spinner animation="grow" variant="light" size="sm" />
                        <Spinner animation="grow" variant="danger" size="sm" />
                        <span className='ms-2'>{t('PleaseWait')}</span>
                    </React.Fragment>
                    ) : t('LoadMore')}
                </Button>}                
            </Card.Footer>
        </Card>
    );
}